export default __webpack_public_path__ + "static/IBMPlexSans-Medium-Latin1-2aa8c8e7baa5a3a3c1db17a62e412ef8.woff2";